const messages = {
  es: {
    translations: {
      signup: {
        title: "Regístrate",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Por favor, inicia sesión!!!.",
          disabled: "El registro de usuarios está deshabilitado en este momento. Por favor, inténtelo de nuevo más tarde.",
          fail: "Error al crear el usuario. Verifica la información proporcionada.",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          company: "Nombre de la Organización",
          phone: "¿Cuál es tu WhatsApp?",
        },
        buttons: {
          submit: "Registrar",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Iniciar Sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
          button: "Acceder",
        },
        buttons: {
          submit: "Entrar",
          register: "¿No tienes una cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Tu suscripción expira en",
          days: "días!",
          day: "día!",
          expirationToday: "¡Tu suscripción expira hoy!",
        },
        token: "Token",
      },
      dashboard: {
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atenciones de hoy: ",
          },
        },
        cards: {
          inAttendance: "En Atención",
          waiting: "Esperando",
          activeAttendants: "Atendentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "Tiempo Prom. de Servicio",
          averageWaitingTime: "Tiempo Prom. de Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Cantidad de Atenciones",
          statusNow: "Actual",
          totalCallsUser: "Total de atenciones por usuario",
          totalAttendances: "Total de atenciones",
          lastOnline: "Última vez en línea",
          lastSessionDuration: "Duración de la última sesión",
          sessionTime: "Tiempo de Sesión",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponible hasta",
        },
        assessments: {
          totalCalls: "Total de Atenciones",
          callsWaitRating: "Atenciones esperando evaluación",
          callsWithoutRating: "Atenciones sin evaluación",
          ratedCalls: "Atenciones evaluadas",
          evaluationIndex: "Índice de evaluación",
          score: "Puntuación",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detractores",
        },
      },
      reports: {
        title: "Informes de Investigaciones Realizadas",
        operator: "Operador",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Informes",
        calls: "Atenciones",
        search: "Investigaciones",
        durationCalls: "Duración de las atenciones",
        grupoSessions: "Atenciones en grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generando informe comprimido, por favor espera.",
          errorToast: "Error al generar el informe",
          back: "Volver",
          groupServiceReport: "Informe de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de apertura",
          dateLastUpdated: "Fecha de Última Actualización",
          agent: "Quién atendió",
          agentClosed: "Quién cerró",
          waitingAssistance: "Esperando asistencia",
          process: "En atención",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activo)",
          inactive: "(Inactivo)",
          quantity: "Cantidad",
          percentage: "porcentaje",
          title: "Informes de Investigaciones Realizadas",
          activeSearch: "Investigación activa",
          inactiveSearch: "Investigación inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando informe comprimido, por favor espera.",
          title: "Informe de Duración de la Atención",
          startService: "Inicio de la atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último atendente",
          durationFinished: "Duración después de finalizar",
        },
        ticketDuration: {
          title: "Informe de Duración de las Atenciones",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizar",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando informe comprimido, por favor espera.",
          title: "Informe de Atención",
        },
        pdf: {
          title: "Lista de Atenciones Realizadas",
          exportTitle: "Lista de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Añadir",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos a Excel",
        buttons: {
          downloadModel: "Descargar plantilla de Excel para importación",
          closed: "Cerrar",
          import: "Selecciona el archivo de Excel para importar Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "¡Espera... Tus conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Llamar Soporte",
        toasts: {
          deleted: "¡Conexión eliminada con éxito!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espera unos momentos",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar Tickets Importados",
          closedImportedMessage:
            "Si confirmas, todos los tickets importados serán cerrados",
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede deshacer.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "¿Estás seguro? Necesitarás escanear el Código QR nuevamente.",
        },
        buttons: {
          add: "Añadir Conexión",
          disconnect: "desconectar",
          tryAgain: "Intentar nuevamente",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          closedImported: "Cerrar Todos los Tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes de WhatsApp",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "Fallo al iniciar la sesión de WhatsApp",
            content:
              "Asegúrate de que tu celular esté conectado a internet e intenta nuevamente, o solicita un nuevo Código QR",
          },
          qrcode: {
            title: "Esperando lectura del Código QR",
            content:
              "Haz clic en el botón 'CÓDIGO QR' y escanea el Código QR con tu celular para iniciar la sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el celular",
            content:
              "Asegúrate de que tu celular esté conectado a internet y que WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo Código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de WhatsApp",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atención Existente",
        },
        form: {
          message: "Este contacto ya está siendo atendido:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contacto ya está esperando atención. ¡Revisa la pestaña Esperando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " inició la atención.",
          access: "accedió al ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "devolvió a la fila.",
          closed: "cerró el ticket",
          reopen: "reabrió el ticket",
          redirect: "- redirigido",
          clientClosed: "Cliente cerró el ticket"
        },
      },
      whatsappModal: {
        title: {
          add: "Añadir Conexión",
          edit: "Editar Conexión",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "NPS",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del dispositivo",
          importOldMessages: "Fecha de inicio de la importación",
          importRecentMessages: "Fecha de fin de la importación",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Selecciona una fila a la que se redirigirán los contactos que no tengan fila asignada",
          default: "Predeterminado",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redirigir a la fila",
          importAlert:
            "ATENCIÓN: Al guardar, tu conexión será cerrada y necesitarás escanear el Código QR nuevamente para importar los mensajes",
          groupAsTicket: "Tratar grupos como tickets",
          timeCreateNewTicket: "Crear nuevo ticket en x minutos",
          maxUseBotQueues: "Enviar bot x veces",
          timeUseBotQueues: "Enviar bot en x minutos",
          expiresTicket: "Cerrar chats abiertos después de x minutos",
          expiresTicketNPS:
            "Cerrar chats esperando evaluación después de x minutos",
          maxUseBotQueuesNPS:
            "Número máximo de veces que se enviará la evaluación",
          closeLastMessageOptions1: "Del atendente/Cliente",
          closeLastMessageOptions2: "Del atendente",
          outOfHoursMessage: "Mensaje fuera de horario laboral",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Enlace a la política de privacidad",
          lgpdMessage: "Mensaje de saludo LGPD",
          lgpdDeletedMessages: "Ofuscar mensaje eliminado por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - La escala debe ser de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo en minutos para enviar el aviso de inactividad",
          flowFixedMessage: "Mensaje fijo para activar el flujo",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          prompt: "Prompt",
          collectiveVacationEnd: "Fecha final",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Fila para importar los mensajes"
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          minutes: "minutos",
        },
        success: "Conexión guardada con éxito.",
        errorSendQueue:
          "Se proporcionó tiempo para redirigir a la fila, pero no se seleccionó ninguna fila. Ambos campos deben estar completos.",
        errorExpiresNPS:
          "Se requiere un tiempo para la evaluación al usar NPS.",
        errorRatingMessage:
          "Se requiere un mensaje de evaluación al usar NPS.",
      },
      qrCode: {
        message: "Escanea el Código QR para iniciar la sesión",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!",
          deletedAll: "¡Todos los contactos han sido eliminados con éxito!" // **Nuevo**
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          deleteAllTitle: "Confirmar Eliminación", // **Nuevo**
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro de que deseas eliminar este contacto? Todas las atenciones relacionadas se perderán.",
          deleteAllMessage:
            "¿Estás seguro de que deseas eliminar todos los contactos? Esta acción no se puede deshacer.", // **Nuevo**
          blockContact: "¿Estás seguro de que deseas bloquear este contacto?",
          unblockContact: "¿Estás seguro de que deseas desbloquear este contacto?",
          importMessage: "¿Deseas importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport: "¿Deseas importar todas las conversaciones del teléfono?"
        },
        buttons: {
          import: "Importar Contactos",
          add: "Añadir Contacto",
          export: "Exportar Contacto",
          deleteAll: "Eliminar Todos los Contactos"
        },
        table: {
          name: "Nombre",
          whatsapp: "Número",
          email: "Correo electrónico",
          actions: "Acciones",
          lastMessage: "Último Mensaje"
        },
        menu: {
          importYourPhone: "Importar del dispositivo predeterminado",
          importToExcel: "Importar / Exportar desde Excel"
        }
      },
      forwardMessage: {
        text: "Reenviado"
      },
      forwardMessageModal: {
        title: "Reenviar Mensaje",
        buttons: {
          ok: "Reenviar"
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
          voiceKey: "Clave de API de Voz",
          voiceRegion: "Región de Voz",
        },
        success: "Prompt guardado con éxito!",
        title: {
          add: "Añadir Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Departamento/Fila",
          max_tokens: "Máximo de Tokens en la Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede deshacer!",
        },
        buttons: {
          add: "Añadir Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Añadir Contacto",
          edit: "Editar Contacto",
        },
        form: {
          mainInfo: "Información del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          email: "Correo electrónico",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot",
          termsLGDP: "Términos LGPD aceptados en:",
          whatsapp: "Conexión Origen: "
        },
        buttons: {
          addExtraInfo: "Añadir información",
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado con éxito.",
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Flujo predeterminado",
      },
      queueModal: {
        title: {
          queueData: "Datos de la Fila",
          text: "Horarios de servicio",
          add: "Añadir Fila",
          edit: "Editar Fila",
          confirmationDelete:
            "¿Estás seguro? Todas las opciones de integración serán eliminadas.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotación",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje fuera de horario",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Lista de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menú",
          message: "Mensaje de retorno",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Lista de archivos",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Añade opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, haciendo que el bot responda con el mensaje de la opción y continúe",
          selectOption: "Selecciona una opción",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para proceder al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para proceder al siguiente nivel",
          selectUser: "Selecciona un Usuario",
          selectQueue: "Selecciona una Fila",
          selectIntegration: "Selecciona una Integración",
          addOptions: "Añadir opciones",
        },
        serviceHours: {
          dayWeek: "Día de la semana",
          startTimeA: "Hora de Inicio - Turno A",
          endTimeA: "Hora de Fin - Turno A",
          startTimeB: "Hora de Inicio - Turno B",
          endTimeB: "Hora de Fin - Turno B",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Añadir Proyecto",
          edit: "Editar Proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración añadida con éxito.",
          editSuccess: "Integración editada con éxito.",
        },
      },
      userModal: {
        warning:
          "¡Para importar mensajes, necesitas escanear el Código QR nuevamente!!!",
        title: {
          add: "Añadir Usuario",
          edit: "Editar Usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Eliminar Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          whatsapp: "Conexión Predeterminada",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Deshabilitado",
          allTicket: "Ver tickets sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menú predeterminado",
          defaultTheme: "Tema Predeterminado",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversaciones de otras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Deshabilitado",
          allUserChat: "Ver conversaciones de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel de Atenciones",
          allowConnections: "Permitir acciones en conexiones",
        },
        tabs: {
          general: "General",
          permissions: "Permisos",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Añadir Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado con éxito.",
      },
      companyModal: {
        title: {
          add: "Añadir Empresa",
          edit: "Editar Empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Empresa guardada con éxito.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Agendamiento",
          edit: "Editar Agendamiento",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Agendamiento",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma"
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Añadir agendamiento"
        },
        success: "Agendamiento guardado con éxito.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en horas para redirigir a lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensaje de saludo de la lane",
          rollbackLaneId: "Volver a Lane después de retomar atención"
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardado con éxito.",
        successKanban: "Lane guardada con éxito.",
      },
      fileModal: {
        title: {
          add: "Añadir lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Añadir archivo",
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción",
        },
        success: "¡Lista de archivos guardada con éxito!",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para comenzar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO ABAJO ⬇️",
          titleFileList: "Lista de archivos",
        },
      },
      chatInternal: {
        new: "Nuevo",
        modal: {
          conversation: "Conversación",
          title: "Título",
          filterUsers: "Filtrar por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no se puede deshacer, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿DESEAS CERRAR TODOS LOS TICKETS?",
        yes: "SÍ",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolveAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "La atención en la que estabas ha sido eliminada.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Abiertos" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar atenciones y mensajes",
          filterConections: "Filtrar por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtrar por Usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a la Fila",
          scredule: "Agendamiento",
          deleteTicket: "Eliminar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar Ticket Con Mensaje de Despedida",
          closedNotMessage: "Cerrar Ticket Sin Mensaje de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a fila",
        fieldQueuePlaceholder: "Selecciona una fila",
        fieldWhatsapp: "Selecciona un WhatsApp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer: "Notas - mensaje interno, no irá al cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo",
        modal: {
          conversation: "Conversación",
          title: "Título",
          filterUsers: "Filtrar por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no se puede deshacer, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Llamado",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Atendiendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
          "No se encontraron atenciones con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar a PDF",
          kanbanActions: "Opciones de Kanban"
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar departamento",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar Contacto",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Añadir",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel",
          tickets: "Atenciones",
          quickMessages: "Respuestas rápidas",
          contacts: "Contactos",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuraciones",
          files: "Lista de archivos",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Agendamientos",
          campaigns: "Campañas",
          annoucements: "Anuncios",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "CRM",
          prompts: "Talk.Ai",
          allConnections: "Gestionar conexiones",
          reports: "Informes",
          management: "Gerencia"
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Salir",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y continuaré tu atención.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, por favor contacta al administrador de la plataforma.",
          },
          message: {
            location: "Ubicación",
            contact: "Contacto",
          },
          notRegister: "Ningún registro",
          refresh: "Actualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Portugués",
        es: "Español",
        en: "Inglés",
        tr: "Turco",
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID del usuario/atendente",
          queueId: "ID de la Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para el envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Media",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Notas Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. \n Para registrar, accede al menú 'Conexiones', haz clic en el botón de editar de la conexión e ingresa el token en el campo correspondiente.",
            comments2:
              "El número para envío no debe tener máscara ni caracteres especiales y debe componerse de:",
            codeCountry: "Código del País",
            code: "Código de Área",
            number: "Número",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se presenta la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensajes de Media",
            instructions:
              "A continuación se presenta la lista de información necesaria para enviar mensajes de media:",
          },
        },
      },
      notifications: {
        noTickets: "No hay notificaciones.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin adjunto",
        confirmationModal: {
          deleteTitle: "Eliminación",
          deleteMessage: "¡Esta acción es irreversible! ¿Deseas proceder?",
        },
        buttons: {
          add: "Añadir",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo añadido con éxito!",
          deleted: "¡Atajo eliminado con éxito!",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir edición",
          add: "Añadir",
          edit: "Editar",
          visao: "Permitir vista",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          owner: "Propietario",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          isGlobal: "Lista Global (visible para todos)",
          okEdit: "Editar",
          okAdd: "Añadir",
          add: "Añadir",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Buscar",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar",
          export: "Exportar" 
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Añadir",
          add: "Añadir",
          edit: "Editar",
          cancel: "Cancelar"
        },
        table: {
          name: "Nombre",
          owner: "Proprietário",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "Correo electrónico",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
          importMessage: "¿Deseas importar contactos de esta hoja de cálculo?",
          importTitle: "Importar"
        },
        toasts: {
          deleted: "Registro eliminado",
          imported: "Contactos importados con éxito.",
          exported: "Contactos exportados con éxito.",
          exporting: "Exportando...",
          importing: "Importando...",
          errorExport: "Ocurrió un error durante la exportación.",
          errorImport: "Ocurrió un error durante la importación.",
          noContactsToExport: "No hay contactos para exportar."
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Buscar",
        subMenus: {
          list: "Panel",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Buscar",
        subMenus: {
          list: "Listado",
          listContacts: "Lista de contactos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo Aleatorio de Disparo",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Mayor Intervalo Después",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de disparo mayor",
          addVar: "Añadir variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Añadir",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contacto",
          option: "Ninguna",
          disabled: "Deshabilitada",
          enabled: "Habilitada",
          status: "Estado",
          scheduledAt: "Agendamiento",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Lectura",
          help: "Utiliza variables como {name}, {number}, {email} o define variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Agendamiento",
            confirmation: "Confirmación",
            contactList: "Lista de Contacto",
            tagList: "Tags",
            statusTicket: "Estado del Ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Añadir",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación realizada con éxito",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado",
        },
      },
      campaignReport: {
        title: "Informe de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Progreso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Lista de Contactos",
        schedule: "Agendamiento",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Anuncios",
        searchPlaceholder: "Buscar",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Anuncio",
          contactLists: "Listas de Anuncios",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Edición de Anuncio",
          add: "Nuevo Anuncio",
          update: "Editar Anuncio",
          readonly: "Solo Lectura",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alta",
            medium: "Media",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Añadir",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        toasts: {
          success: "Operación realizada con éxito",
          deleted: "Registro eliminado",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Añadir fila",
        },
        toasts: {
          success: "Fila guardada con éxito",
          deleted: "Fila eliminada con éxito",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede deshacer! Las atenciones de esta fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas de solo lectura",
        withoutQueue: "Sin fila",
      },
      reports: {
        title: "Informes de Atenciones",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Fila",
          actions: "Acciones",
          lastMessage: "Último Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        searchPlaceholder: "Buscar...",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Añadir Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede deshacer! Y será removida de las filas y conexiones vinculadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Estado",
          name: "Nombre",
          email: "Correo electrónico",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Añadir Usuario",
        },
        toasts: {
          deleted: "Usuario eliminado con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos los datos del usuario serán perdidos. Las atenciones abiertas de este usuario serán movidas a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo electrónico",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Atendentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamiento",
          createdAt: "Creada en",
          dueDate: "Vencimiento",
          lastLogin: "Último Inicio de Sesión",
          actions: "Acciones",
          money: "R$",
          yes: "Sí",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Añadir Empresa",
        },
        toasts: {
          deleted: "Empresa eliminada con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos los datos de la empresa serán perdidos. Los tickets abiertos de este usuario serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Agendamientos",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "R$",
          public: "Público"
        },
      },
      helps: {
        title: "Centro de Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Agendamientos",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que deseas eliminar este Agendamiento?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Agendamiento",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Agendamiento",
        },
        toasts: {
          deleted: "Agendamiento eliminado con éxito.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que deseas eliminar esta Tag?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros de Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminado con éxito.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que deseas eliminar esta Lane?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada con éxito.",
        },
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "¡Lista eliminada con éxito!",
          deletedAll: "¡Todas las listas han sido eliminadas con éxito!",
        },
        buttons: {
          add: "Añadir",
          deleteAll: "Eliminar Todos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Estás seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las listas?",
        },
      },
      settings: {
        success: "Configuraciones guardadas con éxito.",
        title: "Configuraciones",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Agendamiento de Oficina",
            queueManagement: "Gestión por Fila",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de departamento/atendente",
            checkMsgIsGroup: "Ignorar Mensajes de Grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir atendente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp: "¿Informar que no se aceptan llamadas en WhatsApp?",
            sendSignMessage: "Permitir que el atendente elija ENVIAR Firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando solo hay 1 fila",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida en Esperando",
            acceptAudioMessageContact:
              "¿Aceptar recibir audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento LGPD",
            requiredTag: "Tag obligatoria para cerrar ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra fila",
            DirectTicketsToWallets: "Mover automáticamente cliente a cartera",
            showNotificationPending: "Mostrar notificación para tickets pendientes"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage: "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar ticket",
            transferMessage: "Mensaje de transferencia - ${queue.name} = fila destino"
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensaje de bienvenida LGPD",
            linkLGPD: "Enlace a la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje eliminado",
            alwaysConsent: "Siempre solicitar consentimiento",
            obfuscatePhoneUser: "Ofuscar número de teléfono para usuarios",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
        PaymentGateways: {
          title: "Pasarelas de Pago"
        }
      },
      privacyModal: {
        title: "Editar Privacidad de WhatsApp",
        buttons: {
          cancel: "Cancelar",
          okEdit: "Guardar",
        },
        form: {
          menu: {
            all: "Todos",
            none: "Nadie",
            contacts: "Mis contactos",
            contact_blacklist: "Contactos seleccionados",
            match_last_seen: "Similar a Visto por Último",
            known: "Conocidos",
            disable: "Desactivada",
            hrs24: "24 Horas",
            dias7: "7 Días",
            dias90: "90 Días",
          },
          readreceipts: "Para actualizar la privacidad de los recibos de lectura",
          profile: "Para actualizar la privacidad de la foto de perfil",
          status: "Para actualizar la privacidad de los estados",
          online: "Para actualizar la privacidad en línea",
          last: "Para actualizar la privacidad de Última Visto",
          groupadd: "Para actualizar la privacidad de Añadir a grupos",
          calladd: "Para actualizar la privacidad de Añadir a Llamadas",
          disappearing: "Para actualizar el Modo de Desaparición Predeterminado",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Deseas dejar una evaluación de servicio para el cliente?",
          dialogClosingTitle: "¡Finalizando la atención con el cliente!",
          dialogRatingCancel: "Resolver CON Mensaje de Despedida",
          dialogRatingSuccess: "Resolver y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Resolver SIN Mensaje de Despedida",
          ratingTitle: "Elige un menú de evaluación",
          notMessage: "Ningún mensaje seleccionado",
          amount: "Valor de prospección",
          buttons: {
            return: "Regresar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Habilitar integración",
            disableIntegration: "Deshabilitar integración",
            logTicket: "Logs del Ticket",
            requiredTag: "Debes asignar una tag antes de cerrar el ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Escribe un mensaje o presiona / para respuestas rápidas",
        placeholderOpen:
          "Escribe un mensaje o presiona / para respuestas rápidas",
        placeholderClosed:
          "Reabre o acepta este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privado",
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Reenviar",
        talkTo: "Hablar con",
        confirmationModal: {
          title: "¿Eliminar mensaje?",
          message: "Esta acción no se puede deshacer.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha de Vencimiento",
          action: "Acción",
        },
      },
      validation: {
        nameRequired: "El nombre es obligatorio.",
        invalidEmail: "Por favor, introduce un correo electrónico válido.",
        emailRequired: "El correo electrónico es obligatorio.",
        passwordMin: "La contraseña debe tener al menos 5 caracteres.",
        passwordRequired: "La contraseña es obligatoria.",
        phoneInvalid: "El teléfono debe contener solo números y tener 10 o 11 dígitos.",
        planRequired: "Selecciona un plan.",
        dueDateRequired: "La fecha de vencimiento es obligatoria.",
        recurrenceRequired: "Selecciona la recurrencia."
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró ningún WhatsApp predeterminado. Revisa la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ha sido inicializada. Revisa la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Revisa la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudo descargar el medio de WhatsApp. Revisa la página de conexiones.",
        ERR_INVALID_CREDENTIALS:
          "Error de autenticación. Por favor, intenta nuevamente.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar mensaje de WhatsApp. Revisa la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor, inicia sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios ha sido deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontraron configuraciones con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje de WhatsApp, podría ser demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, por favor elige otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario laboral!",
      },
    },
  },
};

export { messages };
